<template>
  <div>
    <el-dialog
      top="5vh"
      v-loading="loading"
      :title="'欠费减免筛选账单，项目：'+house_name"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div style="height: 75vh;overflow-y: auto;">
        <el-button @click="selects(1)">查询</el-button>
        <el-button @click="update(1)">添加</el-button>
        <el-button @click="update(2)">全部添加</el-button>
        <el-button @click="excel">导出</el-button>
        <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
              <el-descriptions-item label="房产信息">
                <el-select v-model="select.house" @change="houses" size="mini" placeholder="可搜索房产" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                    <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item  label="业户">
                <el-select v-model="select.customerid" @change="customer" size="mini" placeholder="可搜索业户" filterable remote clearable reserve-keyword :remote-method="remoteMethod2" style="width: 100%;">
                    <el-option v-for="item in customers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item  label="计费周期">
                <el-date-picker v-model="select.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="select.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item>
              <el-descriptions-item label="收费项目">
                <el-select v-model="select.chargeitem_id" size="mini" multiple filterable collapse-tags placeholder="收费项目" style="width: 85%;">
                    <el-option v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
                </el-select>
                <span style="cursor: pointer;margin-left: 3px;" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
              </el-descriptions-item>
              <el-descriptions-item label="账单读数">
                <Space direction="vertical" size="large">
                  <RadioGroup v-model="select.has_reading">
                    <Radio label=0>全部</Radio>
                    <Radio label=1>有</Radio>
                    <Radio label=2>无</Radio>
                  </RadioGroup>
                </Space>
              </el-descriptions-item>
            </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
          <span style="margin-left: 15px;">总金费：<span style="color: red;">{{money}}</span>元</span>
          <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
          <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="58vh"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="账单ID" width="100"></el-table-column>
            <el-table-column prop="customer_name" label="姓名" width="100"></el-table-column>
            <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
            <el-table-column prop="chargeitem_name" label="收费项目" width="130"></el-table-column>
            <el-table-column label="计费周期" width="180">
              <template slot-scope="scope">
                {{scope.row.startDate}}-{{scope.row.endDate}}
              </template>
            </el-table-column>
            <el-table-column prop="xsc_Price" label="单价" width="80"></el-table-column>
            <el-table-column prop="xsc_Amount" label="数量" width="80"></el-table-column>
            <el-table-column prop="charge" label="应收金额" width="80"></el-table-column>
            <el-table-column prop="adjust_after" label="调后金额" width="80"></el-table-column>
            <el-table-column prop="charges" label="欠费金额" width="80"></el-table-column>
            <el-table-column prop="account_book" label="所属日期" width="100"></el-table-column>
            <el-table-column prop="meter_order_house_id" label="有无读数" width="100">
              <template slot-scope="scope">
                {{scope.row.meter_order_house_id >0 ? '有':'无'}}
              </template>
            </el-table-column>
            <el-table-column prop="state_name" label="状态" width="80"></el-table-column>
            <el-table-column prop="IsFrozen" label="冻结状态" width="80"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pages">
        <Page :total="total" :page-size="page" @on-change="selects" show-total />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import imgurl from "../../../../assets/js/imgurl.js"
  export default {
      // 接受父组件的值
      props: {

      },
      watch:{

      },
      data () {
        return {
          total:0,
          page:15,
          dialogVisible:false,
          tableData: [],
          order: [],
          money_val:0,
          money:0,
          select:{
            page:1,
            pay:'',
            house:'',
            name:'',
            date:'',
            startDate:'',
            endDate:'',
            chargeitem_id:[],
            customerid:'',
            has_reading:'0',
          },
          customers:[],
          house:[],
          chargeitem:[],
          loading:false,
          loading_dade:1,
          pid:'',
          house_name:''
        }
      },
      mounted(){
        //加载收费大类（费项）
        this.$myhttp
          .get("admin/common/getChargeitem", {
            "Content-Type": "application/json",
          })
          .then((backdata) => {
            this.chargeitem = backdata.data.data;
          });
      },
      //事件
      methods: {
        //返回数据
        getInvo(house,pid){
          this.pid=pid;
          this.house = house;
          this.dialogVisible = true;
          this.housePid();
          this.selects(1);
        },
        del(){
          this.select.pay = '';
        },
        //全选
        complete() {
          let data = this.chargeitem;
          let id = data
            .map((ret) => {
              return ret.id;
            })
            .join(",");
          let idarray = "[" + id + "]";
          this.select.chargeitem_id = JSON.parse(idarray);
        },
        //取消
        cancel() {
          this.select.chargeitem_id = [];
        },
        // 添加
        update(e){
          this.message = '';
          this.$confirm('确定操作吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading = true;
            let data = {'select':this.select,'pid':this.pid,'type':e,'order':this.order};
            this.$myhttp.post('admin/OrderPaymentFlow/add',data,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.loading = false;
                if(backdata.data.code == 201){
                  this.$confirm('操作失败：'+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  })
                }else{
                  this.$confirm(''+backdata.data.message, '提示', {
                    confirmButtonText: '关闭',
                    cancelButtonText: '取消',
                    type: 'warning'
                  })
                  this.dialogVisible = false;
                  //调用父组件方法
                  this.$parent.selects(1);
                }
            },err=>{
              this.loading = false;
              this.$Message.error('请求异常!');
            });
          })
        },
        // 查询
        selects(e){
          this.loading_dade = 2;
          this.select.page = e;
          let data = {'select':this.select,'pid':this.pid}
          this.$myhttp.post('admin/OrderPaymentFlow/index',data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.loading_dade = 1;
              this.tableData = backdata.data.data;
              this.total = backdata.data.count;
              this.money = backdata.data.money;
          },err=>{
            this.loading_dade = 1;
            this.$Message.error('请求异常!');
          });
        },
        //导出
        excel(){
          this.$confirm('确定操作吗, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loading_dade = 2;
            let data = {'select':this.select,'pid':this.pid}
            this.$myhttp.post('admin/OrderPaymentFlow/excel',data,{
              'Content-Type': 'application/x-www-form-urlencoded'
              }).then(backdata=>{ // 异步执行成功后
                this.loading_dade = 1;
                var login = window.localStorage.getItem('login');
                var token = window.localStorage.getItem('token');
                // window.location.href = imgurl+'/'+url+'?'+"&login_name="+login+"&token="+token;
                let urls = imgurl+'/'+backdata.data.data+'?'+"&login_name="+login+"&token="+token;
                window.open(urls, '_blank');
            },err=>{
              this.loading_dade = 1;
              this.$Message.error('请求异常!');
            });
          })
        },
        handleClose(done) {
          done();
        },
        handleSelectionChange(val) {
          this.order = val;
          let money = 0;
          this.order.map(req=>{
              money = Number(money) + Number(req.adjust_after);
          })
          this.money_val = money.toFixed(2);
        },
        //远程搜索
        remoteMethod(query){
          if (query !== '') {
            this.$myhttp.get('admin/common/house_name1?house_name='+encodeURIComponent(query)+'&pid='+this.pid,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.house = backdata.data.data;
            });
          }
        },
        //搜索业户
        remoteMethod2(query){
          if (query !== '') {
            this.$myhttp.get('admin/OrderPaymentFlow/customer?house_name='+query+'&pid='+this.pid,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.customers = backdata.data.data;
            });
          }
        },
        customer(e){

        },
        //更换项目id
        houses(e){
          if(e){
            this.house.map(req=>{
              if(req.house == e){
                this.pid = req.erp_pindex_id;
              }
            })
          }
          this.housePid();
        },
        //查询当前项目
        housePid(){
          this.$myhttp.get('admin/common/house_pid?pid='+this.pid+"&house="+encodeURIComponent(this.house),{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data.code == 200){
                this.house_name = backdata.data.data.name;
                this.pid = backdata.data.data.id;
              }
          });
        }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/selectAdiustPayment.vue